<div
  #containerElement
  class="sg-input__container"
  [class.sg-input--focused]="focused"
  [class.sg-input--floating]="shouldFloat"
  [class.sg-input--has-prefix]="prefixIcon || prefixText"
  [class.sg-input--has-prefix-icon]="prefixIcon"
  [class.sg-input--has-value]="!empty"
  [class.sg-input--clearable]="clearable"
  [class.sg-input--show-clear-button]="showClearButton"
  [class.sg-input--disabled]="disabled"
  [class.sg-input--invalid]="isInvalid"
  [class.sg-input--small]="size === 'small'"
  [class.sg-input--secondary]="variant === 'secondary'"
  [class.sg-input--underline]="variant === 'underline'"
  [class.sg-input--pill]="variant === 'pill'"
  [class.sg-input--has-submit]="submitIcon"
  (click)="onContainerClick($event)">
  <!-- The outline structure -->
  <div class="sg-input__outline">
    <div class="sg-input__outline-start"></div>
    <div class="sg-input__outline-notch"></div>
    <div class="sg-input__outline-end"></div>
  </div>
  <!-- Floating label -->
  @if (label) {
    <label class="sg-input__label" [class.sg-label-medium-regular]="!shouldFloat" [class.sg-label-small-regular]="shouldFloat">
      {{ label }}
      @if (isRequired && !disabled) {
        <span class="sg-input__required">*</span>
      }
      @if (labelTooltip && shouldFloat) {
        <sg-info-tooltip
          class="sg-input__info sg-input__info--label"
          variant="sg-label-small-regular"
          [heading]="labelTooltipHeading"
          [text]="labelTooltip"></sg-info-tooltip>
      }
    </label>
  }
  <!-- Input wrapper with icon and native input -->
  <div class="sg-input__wrapper">
    @if (prefixIcon) {
      <mat-icon
        class="sg-input__prefix sg-input__prefix--icon"
        [style.font-size]="prefixIconSize"
        [style.width]="prefixIconSize"
        [style.height]="prefixIconSize">
        {{ prefixIcon }}
      </mat-icon>
    }
    @if (prefixText && !prefixIcon) {
      <span
        #prefixTextElement
        class="sg-input__prefix sg-input__prefix--text"
        [class.sg-label-medium-regular]="size !== 'small'"
        [class.sg-label-small-regular]="size === 'small'">
        {{ prefixText }}
      </span>
    }
    <input
      #inputElement
      class="sg-input__native"
      [class.sg-body-medium-regular]="size !== 'small'"
      [class.sg-body-small-regular]="size === 'small'"
      [type]="type"
      [disabled]="disabled"
      [placeholder]="shouldFloat || !label ? placeholder : ''"
      [attr.aria-label]="label"
      [attr.aria-invalid]="isInvalid"
      [attr.step]="step"
      [attr.min]="min"
      [attr.max]="max"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown)="onKeydown($event)" />
    @if (showClearButton) {
      <button type="button" class="sg-input__clear" tabindex="0" (click)="clear()" aria-label="Clear input">
        <mat-icon>close</mat-icon>
      </button>
    }
    @if (submitIcon) {
      <button type="button" class="sg-input__submit" tabindex="0" [disabled]="disabled" (click)="onSubmitClick()" aria-label="Submit">
        <mat-icon>{{ submitIcon }}</mat-icon>
      </button>
    }
    @if (suffixIcon && !showClearButton && !submitIcon) {
      <mat-icon class="sg-input__suffix sg-input__suffix--icon">{{ suffixIcon }}</mat-icon>
    }
    @if (suffixText && !suffixIcon && !showClearButton && !submitIcon) {
      <span
        class="sg-input__suffix sg-input__suffix--text"
        [class.sg-label-medium-regular]="size !== 'small'"
        [class.sg-label-small-regular]="size === 'small'">
        {{ suffixText }}
      </span>
    }
    @if (labelTooltip && !shouldFloat && !suffixIcon && !suffixText && !showClearButton && !submitIcon) {
      <sg-info-tooltip
        class="sg-input__suffix sg-input__info sg-input__info--field"
        variant="sg-body-medium-regular"
        [heading]="labelTooltipHeading"
        [text]="labelTooltip"></sg-info-tooltip>
    }
  </div>
</div>
<!-- Subscript area -->
@if (subscriptSizing === "fixed" || (subscriptSizing === "dynamic" && (hint || error))) {
  <div class="sg-input__subscript">
    @if (hint && !error) {
      <span class="sg-input__hint sg-body-xsmall-regular" @subscriptAnimation>{{ hint }}</span>
    }
    @if (error) {
      <span class="sg-input__error sg-body-xsmall-regular" @subscriptAnimation>{{ error }}</span>
    }
    @if (subscriptSizing === "fixed" && !hint && !error) {
      <span class="sg-input__spacer sg-body-xsmall-regular">&nbsp;</span>
    }
  </div>
}
